@file:OptIn(org.jetbrains.compose.resources.InternalResourceApi::class)

package bashbuddy.composeapp.generated.resources

import kotlin.OptIn
import kotlin.String
import kotlin.collections.MutableMap
import org.jetbrains.compose.resources.InternalResourceApi
import org.jetbrains.compose.resources.StringResource

private object CommonMainString0 {
  public val app_name: StringResource by 
      lazy { init_app_name() }

  public val auth: StringResource by 
      lazy { init_auth() }

  public val cart: StringResource by 
      lazy { init_cart() }

  public val contact_us: StringResource by 
      lazy { init_contact_us() }

  public val create_event: StringResource by 
      lazy { init_create_event() }

  public val dashboard: StringResource by 
      lazy { init_dashboard() }

  public val detail: StringResource by 
      lazy { init_detail() }

  public val event_details: StringResource by 
      lazy { init_event_details() }

  public val events: StringResource by 
      lazy { init_events() }

  public val favorite_events: StringResource by 
      lazy { init_favorite_events() }

  public val information: StringResource by 
      lazy { init_information() }

  public val leaderboard: StringResource by 
      lazy { init_leaderboard() }

  public val organization_screen: StringResource by 
      lazy { init_organization_screen() }

  public val privacy_policy: StringResource by 
      lazy { init_privacy_policy() }

  public val prize_list: StringResource by 
      lazy { init_prize_list() }

  public val profile: StringResource by 
      lazy { init_profile() }

  public val promo: StringResource by 
      lazy { init_promo() }

  public val reset_password: StringResource by 
      lazy { init_reset_password() }

  public val search: StringResource by 
      lazy { init_search() }

  public val sign_in: StringResource by 
      lazy { init_sign_in() }

  public val sign_up: StringResource by 
      lazy { init_sign_up() }

  public val stripe: StringResource by 
      lazy { init_stripe() }

  public val tabs: StringResource by 
      lazy { init_tabs() }

  public val terms_of_service: StringResource by 
      lazy { init_terms_of_service() }

  public val ticket_details: StringResource by 
      lazy { init_ticket_details() }

  public val update_profile: StringResource by 
      lazy { init_update_profile() }
}

@InternalResourceApi
internal fun _collectCommonMainString0Resources(map: MutableMap<String, StringResource>) {
  map.put("app_name", CommonMainString0.app_name)
  map.put("auth", CommonMainString0.auth)
  map.put("cart", CommonMainString0.cart)
  map.put("contact_us", CommonMainString0.contact_us)
  map.put("create_event", CommonMainString0.create_event)
  map.put("dashboard", CommonMainString0.dashboard)
  map.put("detail", CommonMainString0.detail)
  map.put("event_details", CommonMainString0.event_details)
  map.put("events", CommonMainString0.events)
  map.put("favorite_events", CommonMainString0.favorite_events)
  map.put("information", CommonMainString0.information)
  map.put("leaderboard", CommonMainString0.leaderboard)
  map.put("organization_screen", CommonMainString0.organization_screen)
  map.put("privacy_policy", CommonMainString0.privacy_policy)
  map.put("prize_list", CommonMainString0.prize_list)
  map.put("profile", CommonMainString0.profile)
  map.put("promo", CommonMainString0.promo)
  map.put("reset_password", CommonMainString0.reset_password)
  map.put("search", CommonMainString0.search)
  map.put("sign_in", CommonMainString0.sign_in)
  map.put("sign_up", CommonMainString0.sign_up)
  map.put("stripe", CommonMainString0.stripe)
  map.put("tabs", CommonMainString0.tabs)
  map.put("terms_of_service", CommonMainString0.terms_of_service)
  map.put("ticket_details", CommonMainString0.ticket_details)
  map.put("update_profile", CommonMainString0.update_profile)
}

internal val Res.string.app_name: StringResource
  get() = CommonMainString0.app_name

private fun init_app_name(): StringResource = org.jetbrains.compose.resources.StringResource(
  "string:app_name", "app_name",
    setOf(
      org.jetbrains.compose.resources.ResourceItem(setOf(), "composeResources/bashbuddy.composeapp.generated.resources/values/strings.commonMain.cvr", 10, 32),
    )
)

internal val Res.string.auth: StringResource
  get() = CommonMainString0.auth

private fun init_auth(): StringResource = org.jetbrains.compose.resources.StringResource(
  "string:auth", "auth",
    setOf(
      org.jetbrains.compose.resources.ResourceItem(setOf(), "composeResources/bashbuddy.composeapp.generated.resources/values/strings.commonMain.cvr", 43, 20),
    )
)

internal val Res.string.cart: StringResource
  get() = CommonMainString0.cart

private fun init_cart(): StringResource = org.jetbrains.compose.resources.StringResource(
  "string:cart", "cart",
    setOf(
      org.jetbrains.compose.resources.ResourceItem(setOf(), "composeResources/bashbuddy.composeapp.generated.resources/values/strings.commonMain.cvr", 64, 20),
    )
)

internal val Res.string.contact_us: StringResource
  get() = CommonMainString0.contact_us

private fun init_contact_us(): StringResource = org.jetbrains.compose.resources.StringResource(
  "string:contact_us", "contact_us",
    setOf(
      org.jetbrains.compose.resources.ResourceItem(setOf(), "composeResources/bashbuddy.composeapp.generated.resources/values/strings.commonMain.cvr", 85, 34),
    )
)

internal val Res.string.create_event: StringResource
  get() = CommonMainString0.create_event

private fun init_create_event(): StringResource = org.jetbrains.compose.resources.StringResource(
  "string:create_event", "create_event",
    setOf(
      org.jetbrains.compose.resources.ResourceItem(setOf(), "composeResources/bashbuddy.composeapp.generated.resources/values/strings.commonMain.cvr", 120, 36),
    )
)

internal val Res.string.dashboard: StringResource
  get() = CommonMainString0.dashboard

private fun init_dashboard(): StringResource = org.jetbrains.compose.resources.StringResource(
  "string:dashboard", "dashboard",
    setOf(
      org.jetbrains.compose.resources.ResourceItem(setOf(), "composeResources/bashbuddy.composeapp.generated.resources/values/strings.commonMain.cvr", 157, 29),
    )
)

internal val Res.string.detail: StringResource
  get() = CommonMainString0.detail

private fun init_detail(): StringResource = org.jetbrains.compose.resources.StringResource(
  "string:detail", "detail",
    setOf(
      org.jetbrains.compose.resources.ResourceItem(setOf(), "composeResources/bashbuddy.composeapp.generated.resources/values/strings.commonMain.cvr", 187, 22),
    )
)

internal val Res.string.event_details: StringResource
  get() = CommonMainString0.event_details

private fun init_event_details(): StringResource = org.jetbrains.compose.resources.StringResource(
  "string:event_details", "event_details",
    setOf(
      org.jetbrains.compose.resources.ResourceItem(setOf(), "composeResources/bashbuddy.composeapp.generated.resources/values/strings.commonMain.cvr", 210, 41),
    )
)

internal val Res.string.events: StringResource
  get() = CommonMainString0.events

private fun init_events(): StringResource = org.jetbrains.compose.resources.StringResource(
  "string:events", "events",
    setOf(
      org.jetbrains.compose.resources.ResourceItem(setOf(), "composeResources/bashbuddy.composeapp.generated.resources/values/strings.commonMain.cvr", 252, 22),
    )
)

internal val Res.string.favorite_events: StringResource
  get() = CommonMainString0.favorite_events

private fun init_favorite_events(): StringResource = org.jetbrains.compose.resources.StringResource(
  "string:favorite_events", "favorite_events",
    setOf(
      org.jetbrains.compose.resources.ResourceItem(setOf(), "composeResources/bashbuddy.composeapp.generated.resources/values/strings.commonMain.cvr", 275, 35),
    )
)

internal val Res.string.information: StringResource
  get() = CommonMainString0.information

private fun init_information(): StringResource = org.jetbrains.compose.resources.StringResource(
  "string:information", "information",
    setOf(
      org.jetbrains.compose.resources.ResourceItem(setOf(), "composeResources/bashbuddy.composeapp.generated.resources/values/strings.commonMain.cvr", 311, 35),
    )
)

internal val Res.string.leaderboard: StringResource
  get() = CommonMainString0.leaderboard

private fun init_leaderboard(): StringResource = org.jetbrains.compose.resources.StringResource(
  "string:leaderboard", "leaderboard",
    setOf(
      org.jetbrains.compose.resources.ResourceItem(setOf(), "composeResources/bashbuddy.composeapp.generated.resources/values/strings.commonMain.cvr", 347, 35),
    )
)

internal val Res.string.organization_screen: StringResource
  get() = CommonMainString0.organization_screen

private fun init_organization_screen(): StringResource = org.jetbrains.compose.resources.StringResource(
  "string:organization_screen", "organization_screen",
    setOf(
      org.jetbrains.compose.resources.ResourceItem(setOf(), "composeResources/bashbuddy.composeapp.generated.resources/values/strings.commonMain.cvr", 383, 43),
    )
)

internal val Res.string.privacy_policy: StringResource
  get() = CommonMainString0.privacy_policy

private fun init_privacy_policy(): StringResource = org.jetbrains.compose.resources.StringResource(
  "string:privacy_policy", "privacy_policy",
    setOf(
      org.jetbrains.compose.resources.ResourceItem(setOf(), "composeResources/bashbuddy.composeapp.generated.resources/values/strings.commonMain.cvr", 427, 42),
    )
)

internal val Res.string.prize_list: StringResource
  get() = CommonMainString0.prize_list

private fun init_prize_list(): StringResource = org.jetbrains.compose.resources.StringResource(
  "string:prize_list", "prize_list",
    setOf(
      org.jetbrains.compose.resources.ResourceItem(setOf(), "composeResources/bashbuddy.composeapp.generated.resources/values/strings.commonMain.cvr", 470, 34),
    )
)

internal val Res.string.profile: StringResource
  get() = CommonMainString0.profile

private fun init_profile(): StringResource = org.jetbrains.compose.resources.StringResource(
  "string:profile", "profile",
    setOf(
      org.jetbrains.compose.resources.ResourceItem(setOf(), "composeResources/bashbuddy.composeapp.generated.resources/values/strings.commonMain.cvr", 505, 27),
    )
)

internal val Res.string.promo: StringResource
  get() = CommonMainString0.promo

private fun init_promo(): StringResource = org.jetbrains.compose.resources.StringResource(
  "string:promo", "promo",
    setOf(
      org.jetbrains.compose.resources.ResourceItem(setOf(), "composeResources/bashbuddy.composeapp.generated.resources/values/strings.commonMain.cvr", 533, 29),
    )
)

internal val Res.string.reset_password: StringResource
  get() = CommonMainString0.reset_password

private fun init_reset_password(): StringResource = org.jetbrains.compose.resources.StringResource(
  "string:reset_password", "reset_password",
    setOf(
      org.jetbrains.compose.resources.ResourceItem(setOf(), "composeResources/bashbuddy.composeapp.generated.resources/values/strings.commonMain.cvr", 563, 42),
    )
)

internal val Res.string.search: StringResource
  get() = CommonMainString0.search

private fun init_search(): StringResource = org.jetbrains.compose.resources.StringResource(
  "string:search", "search",
    setOf(
      org.jetbrains.compose.resources.ResourceItem(setOf(), "composeResources/bashbuddy.composeapp.generated.resources/values/strings.commonMain.cvr", 606, 22),
    )
)

internal val Res.string.sign_in: StringResource
  get() = CommonMainString0.sign_in

private fun init_sign_in(): StringResource = org.jetbrains.compose.resources.StringResource(
  "string:sign_in", "sign_in",
    setOf(
      org.jetbrains.compose.resources.ResourceItem(setOf(), "composeResources/bashbuddy.composeapp.generated.resources/values/strings.commonMain.cvr", 629, 27),
    )
)

internal val Res.string.sign_up: StringResource
  get() = CommonMainString0.sign_up

private fun init_sign_up(): StringResource = org.jetbrains.compose.resources.StringResource(
  "string:sign_up", "sign_up",
    setOf(
      org.jetbrains.compose.resources.ResourceItem(setOf(), "composeResources/bashbuddy.composeapp.generated.resources/values/strings.commonMain.cvr", 657, 27),
    )
)

internal val Res.string.stripe: StringResource
  get() = CommonMainString0.stripe

private fun init_stripe(): StringResource = org.jetbrains.compose.resources.StringResource(
  "string:stripe", "stripe",
    setOf(
      org.jetbrains.compose.resources.ResourceItem(setOf(), "composeResources/bashbuddy.composeapp.generated.resources/values/strings.commonMain.cvr", 685, 22),
    )
)

internal val Res.string.tabs: StringResource
  get() = CommonMainString0.tabs

private fun init_tabs(): StringResource = org.jetbrains.compose.resources.StringResource(
  "string:tabs", "tabs",
    setOf(
      org.jetbrains.compose.resources.ResourceItem(setOf(), "composeResources/bashbuddy.composeapp.generated.resources/values/strings.commonMain.cvr", 708, 20),
    )
)

internal val Res.string.terms_of_service: StringResource
  get() = CommonMainString0.terms_of_service

private fun init_terms_of_service(): StringResource = org.jetbrains.compose.resources.StringResource(
  "string:terms_of_service", "terms_of_service",
    setOf(
      org.jetbrains.compose.resources.ResourceItem(setOf(), "composeResources/bashbuddy.composeapp.generated.resources/values/strings.commonMain.cvr", 729, 48),
    )
)

internal val Res.string.ticket_details: StringResource
  get() = CommonMainString0.ticket_details

private fun init_ticket_details(): StringResource = org.jetbrains.compose.resources.StringResource(
  "string:ticket_details", "ticket_details",
    setOf(
      org.jetbrains.compose.resources.ResourceItem(setOf(), "composeResources/bashbuddy.composeapp.generated.resources/values/strings.commonMain.cvr", 778, 42),
    )
)

internal val Res.string.update_profile: StringResource
  get() = CommonMainString0.update_profile

private fun init_update_profile(): StringResource = org.jetbrains.compose.resources.StringResource(
  "string:update_profile", "update_profile",
    setOf(
      org.jetbrains.compose.resources.ResourceItem(setOf(), "composeResources/bashbuddy.composeapp.generated.resources/values/strings.commonMain.cvr", 821, 42),
    )
)
